import React, { useState, useEffect, useContext } from "react";
import Layout from "../../common/Layout";
import "../../../styles/pageStyles/user/user.css";
import { Formik, Form } from "formik";
import config from "../../../config/Config";
import { useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import UserForm from "./UserForm";
import { UserRoleContext } from "../../../context/FormContext";

const User = (props) => {
  const [role, setRole] = useContext(UserRoleContext);
  const [postType, setPostType] = useState("create");
  const [showActive, setShowActive] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [roles, setRoles] = useState([]);
  const [severityType, setSeverityType] = useState("");
  const [snackbarMssg, setSnackbarMssg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [createdUserId, setCreatedUserId] = useState();
  const [userData, setUserData] = useState({});
  var tokenStr = localStorage.getItem("access_token");
  const navigate = useNavigate();

  useEffect(() => {
    var tokenStr = localStorage.getItem("access_token");
    fetch(`${config.baseUrl}roles/`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${tokenStr}`,
        "Content-Type": "application/json",
      },
    }).then(async (response) => {
      const result = await response.json();
      if (response.status === 201 || response.status === 200) {
        setRoles(result);
      } else if (response.status === 403) {
        localStorage.setItem("access_token", "");
        navigate("/");
      }
    });
  }, []);

  const initialValues = {
    id: "",
    email: "",
    username: "",
    last_name: "",
    first_name: "",
    groups: [],
    pType: "",
    is_locked: "",
    is_active: "",
  };

  const validate = (values) => {
    let errors = {};
    if (
      !values.email ||
      !values.last_name ||
      !values.first_name ||
      !values.groups ||
      !values.username
    ) {
      errors.username = "Please fill the mandatory(*) fields";
    }
    if (!values.email) {
      errors.email = "Please enter an email address";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = "Invalid email address";
    }

    return errors;
  };

  const onSubmit = (values) => {
    var tempGrpIds = [];
    values.groups?.forEach((element) => {
      var tempGr = roles.find((i) => i.name === element);
      tempGrpIds.push(tempGr.id);
    });
    if (postType === "create") {
      createUser(values, tempGrpIds);
    } else {
      updateUser(values, tempGrpIds);
    }
  };

  const createUser = (values, tempGrpIds) => {
    setIsLoading(true);
    // setUserData(values)
    fetch(`${config.baseUrl}user/`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${tokenStr}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        first_name: values.first_name,
        last_name: values.last_name,
        email: values.email,
        groups: tempGrpIds,
        username: values.username,
      }),
    })
      .then(async (response) => {
        const results = await response.json();
        if (response.status === 201 || response.status === 200) {
          setSnackbarMssg(results.message);
          setSeverityType("success");
          setOpenSnackbar(true);
          setRole(results);
          await sleep(2000);
          setCreatedUserId(results.user_info.id);
          // setUserData(results)
          setPostType("edit");
          setIsLoading(false);
        } else if (response.status === 403) {
          localStorage.setItem("access_token", "");
          navigate("/");
          setIsLoading(false);
        } else {
          if (results.detail) {
            setSnackbarMssg(results.detail);
            setSeverityType("error");
            setOpenSnackbar(true);
            setIsLoading(false);
          } else {
            setSnackbarMssg("Something Went Wrong");
            setSeverityType("error");
            setOpenSnackbar(true);
            setIsLoading(false);
          }
        }
      })
      .catch((error) => {});
  };

  const updateUser = (values, tempGrpIds) => {
    const id = createdUserId ? createdUserId : values.id;
    setIsLoading(true);
    fetch(`${config.baseUrl}user/${id}/`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${tokenStr}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: id,
        first_name: values.first_name,
        last_name: values.last_name,
        email: values.email,
        groups: tempGrpIds,
        username: values.username,
      }),
    })
      .then(async (response) => {
        const results = await response.json();
        if (response.status === 200) {
          setSnackbarMssg(results.message);
          setRole(results);
          // setUserData(results)
          setSeverityType("success");
          setOpenSnackbar(true);
          await sleep(2000);
          setIsLoading(false);
        } else if (response.status === 403) {
          localStorage.setItem("access_token", "");
          navigate("/");
          setIsLoading(false);
        } else {
          if (results.detail) {
            setSnackbarMssg(results.detail);
            setSeverityType("error");
            setOpenSnackbar(true);
            setIsLoading(false);
          } else {
            setSnackbarMssg("Something Went Wrong");
            setSeverityType("error");
            setOpenSnackbar(true);
            setIsLoading(false);
          }
        }
      })
      .catch((error) => {});
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const userFormProps = {
    roles,
    showActive,
    postType,
    isLoading,
    initialValues,
    setShowActive,
    setPostType,
    createdUserId,
    setSnackbarMssg,
    setSeverityType,
    setOpenSnackbar,
    userData,
    setUserData,
  };
  return (
    <>
      <div className="user-container">
        <div>
          <h3
            style={{
              margin: "18px 0px",
              padding: "5px 0px",
              fontFamily: "proxima-semibold",
            }}
          >
            {postType === "create" ? "Create User" : "Edit User"}
          </h3>
        </div>
        <Formik
          initialValues={initialValues}
          validate={validate}
          onSubmit={onSubmit}
        >
          {({
            values,
            handleChange,
            handleBlur,
            errors,
            touched,
            isValid,
            setFieldValue,
          }) => (
            <Form>
              <UserForm props={userFormProps} />
            </Form>
          )}
        </Formik>
        <Snackbar
          open={openSnackbar}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={severityType}
            elevation={6}
            variant="filled"
          >
            <div className="error" style={{ color: "white" }}>
              <span>{snackbarMssg}</span>
            </div>
          </Alert>
        </Snackbar>
      </div>
    </>
  );
};

export default Layout(User);
